module.exports = __webpack_public_path__ + "static/img/equick.fc64cb60.png";